<template>
  <div class="invitation" style="padding-top: 0.49rem">
    <van-swipe :loop="false">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img v-lazy="image" style="width: 100%; height: 100%" />
        <div
          class="btnBox"
          :class="index == 0 ? 'page1' : index == 1 ? 'page2' : 'page3'"
        >
          <!-- <van-button type="primary" @click="toShare()">立即分享</van-button>
          <van-button type="primary" @click="toSave()">保存海报</van-button> -->
        </div>
      </van-swipe-item>
    </van-swipe>
    <div class="tabToShare">长按图片分享</div>
  </div>
</template>

<script>
import Vue from "vue";
import { Lazyload } from "vant";
import { invitationList } from "../../api/home";
Vue.use(Lazyload);
export default {
  data() {
    return {
      images: [],
      shareList: [],
    };
  },
  methods: {
    toSave() {},
    toShare() {},
  },
  created() {
    invitationList()
      .then((res) => {
        this.shareList = res.data.backdata.share_pic;
        for (let i = 0; i < this.shareList.length; i++) {
          this.images.push(this.shareList[i].pic);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style lang='scss'>
// 轮播图
.invitation {
  width: 3.75rem;
  height: 100%;
  .tabToShare {
    position: fixed;
    right: 0;
    top: 2.75rem;
    z-index: 14;
    width: 0.22rem;
    font-size: 0.12rem;
    line-height: 0.14rem;
    background: #88b9eb;
    text-align: center;
    padding: 0.08rem 0.05rem;
    border-radius: 0.1rem 0 0 0.1rem;
    color: #f7f2f2;
  }
  .van-swipe {
    width: 100%;
    height: 100%;
    // 小圆点
    .van-swipe__indicators {
      bottom: 1.5rem;
      // 没选择时的小圆点
      .van-swipe__indicator {
        width: 0.11rem;
        height: 0.11rem;
        background-color: #000000;
        border-radius: 50%;
      }
      .van-swipe__indicator {
        opacity: 0.2;
      }
      .van-swipe__indicator--active {
        opacity: 1;
      }
      .van-swipe__indicator:not(:last-child) {
        margin-right: 0.11rem;
      }
    }
    // 按钮
    .btnBox {
      width: 100%;
      height: 1.03rem;
      position: absolute;
      bottom: 0.31rem;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      .van-button--normal {
        width: 2.72rem;
        height: 0.44rem;
        border: none;
        background: linear-gradient(0deg, #ee4e46 0%, #ff7979 100%);

        font-size: 0.16rem;
        color: #ffffff;
        border-radius: 0.03rem;
      }
    }
    .page1 {
      .van-button:nth-child(1) {
        background: #1b1b1b;
      }
      .van-button:nth-child(2) {
        background: #1b1b1b;
      }
    }
    .page2 {
      .van-button:nth-child(1) {
        background: linear-gradient(0deg, #ee4e46 0%, #ff7979 100%);
      }
      .van-button:nth-child(2) {
        color: #333333;
        background: linear-gradient(0deg, #e5c780 0%, #ffebbc 100%);
      }
    }

    .page3 {
      .van-button:nth-child(1) {
        background: #d0d6e4;
        color: #333333;
      }
      .van-button:nth-child(2) {
        background: #7997bf;
      }
    }
  }
}
</style>